import axios from 'axios';
import apiConfig from '../api.config';

export default function finishQuickguide({ userId }) {
  const {
    host,
    URIs: { finishQuickguide },
  } = apiConfig;

  const uri = `${host}${finishQuickguide}/${userId}`;

  return axios
    .put(uri, JSON.stringify(), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
